import { stateStatusType, VideoCategoryProps } from './actionType';

// FetchVideoCategoriesState
export interface FetchVideoCategoriesState {
    isLoading: boolean;
    error: string | null;
    categories: VideoCategoryProps[];
    status: stateStatusType | null;
    delete: string | null;
}

export const initialVideoCategoriesState: FetchVideoCategoriesState = {
    isLoading: false,
    error: null,
    categories: [],
    status: null,
    delete: null
};

export interface VideoCategoryState {
    videoCategoriesState: FetchVideoCategoriesState;
}

export const initialState: VideoCategoryState = {
    videoCategoriesState: initialVideoCategoriesState,
};


